import { AxiosResponse } from 'axios';

import {
  IArticleCategory,
  ICreateArticleCategory,
} from './../common/types/article';

import { $host } from './index';

export const getAllArticleCategories = async () => {
  const {
    data: { data },
  } = await $host.get<AxiosResponse<IArticleCategory[]>>(
    'admin/article-categories',
  );

  return data;
};

export const getArticleCategoryById = async (id: IArticleCategory['id']) => {
  const {
    data: { data },
  } = await $host.get<AxiosResponse<IArticleCategory>>(
    `admin/article-categories/${id}`,
  );

  return data;
};

export const deleteArticleCategory = async (id: IArticleCategory['id']) => {
  const { data } = await $host.delete<AxiosResponse<IArticleCategory>>(
    `admin/article-categories/${id}`,
  );

  return data.data;
};

export const createArticleCategory = async (params: ICreateArticleCategory) => {
  const { data } = await $host.post<AxiosResponse<IArticleCategory>>(
    `admin/article-categories`,
    params,
  );

  return data.data;
};

export const editArticleCategory = async (
  id: IArticleCategory['id'],
  params: ICreateArticleCategory,
) => {
  const { data } = await $host.put<AxiosResponse<IArticleCategory>>(
    `admin/article-categories/${id}`,
    params,
  );

  return data.data;
};
